import "./Contact.css";

const Footer = () => {
    return (<div className="footer-container">
        <p className="footer-detail">©️ 2022 SHAO WEI PRODUCTION 🔥</p>
    </div>)
}

export default Footer;